import { render, staticRenderFns } from "./SearchBoxListItemSimple.vue?vue&type=template&id=c21d02e2&scoped=true&lang=html"
import script from "./SearchBoxListItemSimple.vue?vue&type=script&lang=js"
export * from "./SearchBoxListItemSimple.vue?vue&type=script&lang=js"
import style0 from "./SearchBoxListItemSimple.vue?vue&type=style&index=0&id=c21d02e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21d02e2",
  null
  
)

export default component.exports